// MenuItem.vue
<template>
  <div
    class="subitem"
    :class="{ active }"
    @click="$emit('click')"
  >
    {{ $t(label) }}
    <div v-if="number" class="number">{{ number }}</div>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    label: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    number: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped src="@/styles/_left_menu.scss">
/* you can leave this empty or add component-specific overrides */
</style>
